import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'loyalty-ui';

  constructor() {}

  ngOnInit() {
    // if (!this.windowRef.isBrowser) return;
    
    // this.router.events.subscribe(evt => {
    //   if (evt instanceof NavigationEnd) {
    //     // send PageView on every client-side navigation
    //     (window as any).fbq && (window as any).fbq('track', 'PageView');
    //   }
    // });
  }
}
